import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class NavItem extends React.Component {
	render() {
		return (
			<div className={`ambifiNavItem ${this.props.selected ? "ambifiNavItemSelected" : ""}`} onClick={this.props.onClick}>
				<div className="ambifiNavItemHeader">
					<div className="ambifiNavItemIconWrap">
						<FontAwesomeIcon fixedWidth={true} className="ambifiNavItemIcon" icon={this.props.icon} />
						<div className="ambifiNavItemBubble" style={{ display: (this.props.bubbleCount && this.props.bubbleCount > 0) ? "flex" : "none" }}>
							{this.props.bubbleCount}
						</div>
					</div>
					<div className="ambifiNavItemLabel">{this.props.label}</div>
				</div>
			</div>
		);
	}
}

export default NavItem;
